import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './noContent.scss';

const NoContent = ({ noContentLabels, type }) => {
  return (
    <div className='vf-result-content'>
      <p className='vf-result-content__label'>
        { noContentLabels[`noContentLabels_${type}`] || 'Vi kunde inte hitta några passande resultat' }
      </p>
    </div>
  )
} 

NoContent.propTypes = {
  type: PropTypes.string.isRequired,
  noContentLabels: PropTypes.shape({
    noContentLabel_general: PropTypes.string,
    noContentLabel_hotels: PropTypes.string,
    noContentLabel_destinations: PropTypes.string,
    noContentLabel_excursions: PropTypes.string,
    noContentLabel_grouptrips: PropTypes.string,
  }).isRequired,
}

const mapStateToProps = (state) => {
  return {
    noContentLabels: state.attributeCollection.noContentLabels,
  };
};

export default connect(mapStateToProps)(NoContent)